import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HistoryUserDetailsQueryVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;


export type HistoryUserDetailsQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly clinic?: string | null, readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null };


export const HistoryUserDetailsDocument = gql`
    query HistoryUserDetails($userId: String!) {
  user(_id: $userId) {
    person {
      firstname
      lastname
    }
    clinic
  }
}
    `;

/**
 * __useHistoryUserDetailsQuery__
 *
 * To run a query within a React component, call `useHistoryUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useHistoryUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<HistoryUserDetailsQuery, HistoryUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoryUserDetailsQuery, HistoryUserDetailsQueryVariables>(HistoryUserDetailsDocument, options);
      }
export function useHistoryUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoryUserDetailsQuery, HistoryUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoryUserDetailsQuery, HistoryUserDetailsQueryVariables>(HistoryUserDetailsDocument, options);
        }
export type HistoryUserDetailsQueryHookResult = ReturnType<typeof useHistoryUserDetailsQuery>;
export type HistoryUserDetailsLazyQueryHookResult = ReturnType<typeof useHistoryUserDetailsLazyQuery>;
export type HistoryUserDetailsQueryResult = Apollo.QueryResult<HistoryUserDetailsQuery, HistoryUserDetailsQueryVariables>;